import React from 'react';
import {
    Box,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Table
} from '@material-ui/core';

export default class ComponentToPrint extends React.Component {
    render() {
        const selectedSearchValues = this.props.searchData;
        const creditArray = this.props.creditArray;
        const debitArray = this.props.debitArray;
        const totalCreditAmount = this.props.totalCreditAmount;
        const totalDebitAmount = this.props.totalDebitAmount;
        const openingBalance = this.props.openingBalance;
        const isReconciliationCompleted = this.props.isReconciliationCompleted;
        const completedReconciliation = this.props.completedReconciliation;
        const bankReconciliationDetails = this.props.bankReconciliationDetails;
        const transactionModeLookup = {
            1: 'Cheque',
            2: 'Fund Transfer',
            3: 'Cash'
        };
        return (
            <div>
                <div
                    style={{
                        width: '1093px',
                        height: '1059px',
                        padding: '20px',
                        marginBottom: '14rem'
                    }}
                >
                    <br />
                    <h2>
                        <center>
                            <u>Bank Reconciliation Report</u>
                        </center>
                    </h2>
                    <h3>
                        <center>{'Factory : ' + selectedSearchValues.factoryName}  </center>
                    </h3>
                    <h4 style={{ textAlign: 'left' }}>
                        <span>
                            {'Bank Account: ' + selectedSearchValues.accountType}
                        </span>
                        <br></br>
                        <span>
                            {'Period: ' + bankReconciliationDetails.month + ' / ' + bankReconciliationDetails.year}
                        </span>
                    </h4>
                    <br></br>
                    <h4 style={{ textAlign: 'right', padding: '6px' }}>
                        <span>
                            {'Cash Book Closing Balance : ' +
                                (isReconciliationCompleted ?
                                    (completedReconciliation?.openingBalance ?? 0) :
                                    (openingBalance ?? 0)
                                ).toLocaleString('en-US', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}
                        </span>
                    </h4>
                    <div>&nbsp;</div>
                    <div>
                        <Box minWidth={1050}>
                            <TableContainer style={{ marginLeft: '0rem', border: "1px black solid" }}>
                                <Table aria-label="caption table">
                                    <TableHead>
                                        <TableRow style={{ borderTop: "1px black solid" }}>
                                            <TableCell align={'left'}></TableCell>
                                            <TableCell align={'left'}>Transaction Mode</TableCell>
                                            <TableCell align={'left'}>Cheque Number</TableCell>
                                            <TableCell align={'center'}>Cheque Date</TableCell>
                                            <TableCell align={'center'}>Voucher Date</TableCell>
                                            <TableCell align={'center'}>Voucher Number</TableCell>
                                            <TableCell align={'center'}>Narration</TableCell>
                                            <TableCell align={'center'}>Amount</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableCell align={'left'} style={{ fontWeight: 'bold' }}> <u>Unpresented cheques</u> </TableCell>
                                    <TableBody >
                                        {creditArray.map((data, index) => (
                                            <>
                                                <TableRow key={index}>
                                                    <TableCell
                                                        align={'center'}
                                                        component="th"
                                                        scope="row"
                                                        style={{ borderBottom: 'none' }}
                                                    >
                                                    </TableCell>
                                                    <TableCell
                                                        align={'center'}
                                                        component="th"
                                                        scope="row"
                                                        style={{ borderBottom: 'none' }}
                                                    >
                                                        {transactionModeLookup[data.modeoftransactionID ? data.modeoftransactionID : '-']}
                                                    </TableCell>
                                                    <TableCell
                                                        align={'center'}
                                                        component="th"
                                                        scope="row"
                                                        style={{ borderBottom: 'none' }}
                                                    >
                                                        {data.chequeNumber ? data.chequeNumber : '-'}
                                                    </TableCell>
                                                    <TableCell
                                                        align={'center'}
                                                        component="th"
                                                        scope="row"
                                                        style={{ borderBottom: 'none' }}
                                                    >
                                                        {data.date.split("T")[0]}
                                                    </TableCell>
                                                    <TableCell
                                                        align={'center'}
                                                        component="th"
                                                        scope="row"
                                                        style={{ borderBottom: 'none' }}
                                                    >
                                                        {data.date.split("T")[0]}
                                                    </TableCell>
                                                    <TableCell
                                                        align={'center'}
                                                        component="th"
                                                        scope="row"
                                                        style={{ borderBottom: 'none' }}
                                                    >
                                                        {data.referenceNumber}
                                                    </TableCell>
                                                    <TableCell
                                                        align={'center'}
                                                        component="th"
                                                        scope="row"
                                                        style={{ borderBottom: 'none' }}
                                                    >
                                                        {data.description ? data.description : '-'}
                                                    </TableCell>
                                                    <TableCell
                                                        align={'right'}
                                                        component="th"
                                                        scope="row"
                                                        style={{ borderBottom: 'none', marginRight: '5px' }}
                                                    >
                                                        {(data.credit).toLocaleString('en-US', {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        })}
                                                    </TableCell>
                                                </TableRow>
                                            </>
                                        ))}
                                        <TableRow style={{ fontWeight: 'bold', borderBottom: "1px solid black" }}>
                                            <TableCell align={'left'} colSpan={3} style={{ fontWeight: 'bold' }}>
                                            </TableCell>
                                            <TableCell align={'left'} colSpan={4} style={{ fontWeight: 'bold' }}>
                                            </TableCell>
                                            <TableCell align={'right'} style={{ fontWeight: 'bold' }}>
                                                {(totalCreditAmount).toLocaleString('en-US', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </TableCell>
                                        </TableRow>
                                        <TableCell align={'left'} style={{ width: "20%", fontWeight: 'bold' }}> <u>Unrealized cheques </u> </TableCell>
                                        {debitArray.map((data, index) => (
                                            <>
                                                <TableRow key={index}>
                                                    <TableCell
                                                        align={'center'}
                                                        component="th"
                                                        scope="row"
                                                        style={{ borderBottom: 'none' }}
                                                    >
                                                    </TableCell>
                                                    <TableCell
                                                        align={'center'}
                                                        component="th"
                                                        scope="row"
                                                        style={{ borderBottom: 'none' }}
                                                    >
                                                        {transactionModeLookup[data.modeoftransactionID ? data.modeoftransactionID : '-']}
                                                    </TableCell>
                                                    <TableCell
                                                        align={'center'}
                                                        component="th"
                                                        scope="row"
                                                        style={{ borderBottom: 'none' }}
                                                    >
                                                        {data.chequeNumber ? data.chequeNumber : '-'}
                                                    </TableCell>
                                                    <TableCell
                                                        align={'center'}
                                                        component="th"
                                                        scope="row"
                                                        style={{ borderBottom: 'none' }}
                                                    >
                                                        {data.date.split("T")[0]}
                                                    </TableCell>
                                                    <TableCell
                                                        align={'center'}
                                                        component="th"
                                                        scope="row"
                                                        style={{ borderBottom: 'none' }}
                                                    >
                                                        {data.date.split("T")[0]}
                                                    </TableCell>
                                                    <TableCell
                                                        align={'center'}
                                                        component="th"
                                                        scope="row"
                                                        style={{ borderBottom: 'none' }}
                                                    >
                                                        {data.referenceNumber}
                                                    </TableCell>
                                                    <TableCell
                                                        align={'center'}
                                                        component="th"
                                                        scope="row"
                                                        style={{ borderBottom: 'none' }}
                                                    >
                                                        {data.description ? data.description : '-'}
                                                    </TableCell>
                                                    <TableCell
                                                        align={'right'}
                                                        component="th"
                                                        scope="row"
                                                        style={{ borderBottom: 'none', marginRight: '5px' }}
                                                    >
                                                        {(data.debit).toLocaleString('en-US', {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        })}
                                                    </TableCell>
                                                </TableRow>
                                            </>
                                        ))}
                                        <TableRow style={{ fontWeight: 'bold', borderTop: "1px solid black", borderBottom: "1px solid black" }}>
                                            <TableCell align={'left'} colSpan={3} style={{ fontWeight: 'bold', borderTop: "1px solid black" }}>
                                            </TableCell>
                                            <TableCell align={'left'} colSpan={4} style={{ fontWeight: 'bold', borderTop: "1px solid black" }}>
                                            </TableCell>
                                            <TableCell align={'right'} style={{ fontWeight: 'bold', borderTop: "1px solid black" }}>
                                                {totalDebitAmount.toLocaleString('en-US', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow style={{ fontWeight: 'bold', borderTop: "1px solid black", borderBottom: "1px solid black" }}>
                                            <TableCell align={'left'} colSpan={3} style={{ fontWeight: 'bold', borderTop: "1px solid black" }}>
                                                Total Amount
                                            </TableCell>
                                            <TableCell align={'left'} colSpan={4} style={{ fontWeight: 'bold', borderTop: "1px solid black" }}>
                                            </TableCell>
                                            <TableCell align={'right'} style={{ fontWeight: 'bold', borderTop: "1px solid black" }}>
                                                {(totalCreditAmount - totalDebitAmount).toLocaleString('en-US', {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2
                                                })}
                                            </TableCell>
                                        </TableRow>
                                        <TableRow style={{ fontWeight: 'bold', borderTop: "1px solid black", borderBottom: "1px solid black" }}>
                                            <TableCell align={'left'} colSpan={3} style={{ fontWeight: 'bold', borderTop: "1px solid black" }}>
                                                Bank Statement Closing Balance
                                            </TableCell>
                                            <TableCell align={'right'} colSpan={4} style={{ fontWeight: 'bold', borderTop: "1px solid black" }}>
                                            </TableCell>
                                            <TableCell align={'right'} style={{ fontWeight: 'bold', borderTop: "1px solid black" }}>
                                                {(isReconciliationCompleted ?
                                                    (completedReconciliation?.openingBalance ?? 0) + (totalCreditAmount - totalDebitAmount) :
                                                    (openingBalance ?? 0) + (totalCreditAmount - totalDebitAmount)).toLocaleString('en-US', {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2
                                                    })}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                    </div>
                    <div>
                        <br></br>
                        <Table style={{ border: 'none', marginTop: '7%' }}>
                            <TableRow style={{ border: 'none' }}>
                                <TableCell align={'left'} style={{ borderBottom: 'none' }}>___________________________</TableCell>
                                <TableCell align={'right'} style={{ borderBottom: 'none' }}>___________________________</TableCell>
                            </TableRow>
                            <TableRow style={{ border: 'none' }}>
                                <TableCell align={'left'} style={{ borderBottom: 'none' }}>Created by</TableCell>
                                <TableCell align={'right'} style={{ borderBottom: 'none' }}>Approved by</TableCell>
                            </TableRow>
                        </Table>
                    </div>
                </div>
            </div>
        );
    }
}
